import { useEffect } from "react";
import { gsap } from "gsap";

interface RotateYAnimationProps {
    svgElement: SVGElement;
    rotateAngle: number,
    animationSpeed: number;
  }

  const RotateYAnimation: React.FC<RotateYAnimationProps> = ({
    svgElement,
    rotateAngle = 20,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        rotateY: rotateAngle,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, rotateAngle, animationSpeed]);
  
    return null;
  };
   
export default RotateYAnimation;
